import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";

export default function ResetPassword() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password minimo 6 caratteri");
    if (password !== confirm) return toast.error("Le password non coincidono");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password aggiornata. Accedi con la nuova password.");
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore reset");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen text-slate-100">
      <Navbar />
      <main className="mx-auto max-w-md px-4 py-16">
        <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-8">
          <Lock className="h-8 w-8 text-cyan-300" />
          <h1 className="mt-3 text-2xl font-bold">Nuova password</h1>
          {!token ? (
            <p className="mt-3 text-sm text-red-300">Token mancante. Usa il link ricevuto via email.</p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label className="text-slate-300">Nuova password</Label>
                <Input
                  type="password"
                  required
                  minLength={6}
                  data-testid="reset-password-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mt-1 border-slate-800 bg-slate-950 text-slate-100"
                />
              </div>
              <div>
                <Label className="text-slate-300">Conferma password</Label>
                <Input
                  type="password"
                  required
                  minLength={6}
                  data-testid="reset-confirm-input"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  className="mt-1 border-slate-800 bg-slate-950 text-slate-100"
                />
              </div>
              <Button
                type="submit"
                disabled={busy}
                data-testid="reset-submit-btn"
                className="w-full bg-cyan-400 text-slate-950 hover:bg-cyan-300"
              >
                {busy ? "Aggiornamento..." : "Reimposta password"}
              </Button>
            </form>
          )}
        </div>
      </main>
    </div>
  );
}
